/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerStore from 'stores/ActionDrawerStore';
import DashboardStore from 'stores/DashboardStore';
import Loading from 'components/Loading/Loading';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import DeleteEmailDomainError from './DeleteEmailDomainError/DeleteEmailDomainError';
import DeleteEmailDomainSuccess from './DeleteEmailDomainSuccess/DeleteEmailDomainSuccess';

import styles from '../../../ActionDrawer.module.scss';

export type DeleteEmailDomainProps = {
  formData: { id: string },
};

type InjectedProps = {
  actionDrawerStore: ActionDrawerStore,
  dashboardStore: DashboardStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'dashboardStore')
@observer
export default class DeleteEmailDomain extends ComponentWithInjectedProps<
  DeleteEmailDomainProps,
  {},
  InjectedProps
> {
  componentDidMount() {
    const { actionDrawerStore, formData } = this.props;

    // Do work
    actionDrawerStore.removeDomain(formData.id);
  }

  render(): React.Element<*> {
    const { t, formData, currentAccountDetails, actionDrawerStore } = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:email_domains.delete_email_domain')} />
          <DeleteEmailDomainError />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      const { dashboardStore } = this.props;

      dashboardStore.removeDashboardFromLocal();

      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:email_domains.delete_email_domain')} />
          <DeleteEmailDomainSuccess />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:email_domains.delete_email_domain')} />
      </div>
    );
  }
}
